module.exports = __webpack_public_path__ + "img/thumb_37.d146022e.jpg";